var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"2000"}},[_c('v-card-actions',{staticClass:"p-0",staticStyle:{"cursor":"pointer","background-color":"#ffca00"},on:{"click":function($event){_vm.show = !_vm.show}}},[_c('h4',{staticClass:"px-3 mt-2"},[_vm._v("Faturamentos")]),(_vm.active)?_c('span',{staticClass:"w-full"},[_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('vs-col',{attrs:{"vs-type":"flex","vs-w":"3","vs-justify":"flex-start","vs-align":"flex-start"}}),_c('vs-col',{attrs:{"vs-type":"flex","vs-w":"4.5","vs-justify":"flex-start","vs-align":"flex-start"}},[_c('metaChart',{attrs:{"tipo":3,"valores":[
              _vm.relatorioFaturamento.planos.metas.qtd_total,
              (_vm.relatorioFaturamento.planos.metas.qtd_meta /
                _vm.filtro.diasUteis) *
                _vm.filtro.diasCorridos
            ],"percent":parseFloat(
                (_vm.relatorioFaturamento.planos.metas.qtd_total /
                  ((_vm.relatorioFaturamento.planos.metas.qtd_meta /
                    _vm.filtro.diasUteis) *
                    _vm.filtro.diasCorridos)) *
                  100
              ).toFixed(2)}})],1),_c('vs-col',{attrs:{"vs-type":"flex","vs-w":"4.5","vs-justify":"flex-start","vs-align":"flex-start"}},[_c('metaChart',{attrs:{"tipo":3,"valores":[
              _vm.$currency(
                parseFloat(_vm.relatorioFaturamento.planos.metas.valor_total)
              ),
              _vm.$currency(
                parseFloat(
                  (_vm.relatorioFaturamento.planos.metas.valor_meta /
                    _vm.filtro.diasUteis) *
                    _vm.filtro.diasCorridos
                )
              )
            ],"percent":parseFloat(
                (_vm.relatorioFaturamento.planos.metas.valor_total /
                  ((_vm.relatorioFaturamento.planos.metas.valor_meta /
                    _vm.filtro.diasUteis) *
                    _vm.filtro.diasCorridos)) *
                  100
              ).toFixed(2)}})],1)],1)],1):_vm._e()]),_c('v-expand-transition',[(_vm.show)?_c('div',[_c('v-card-text',{staticClass:"p-0 mt-2"},[_c('div',[_c('div',{staticClass:"vs-con-loading__container",attrs:{"id":"container-faturamento"}},[(_vm.active)?_c('div',[_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"flex-start","vs-align":"center"}},[_c('vs-col',{attrs:{"vs-type":"flex","vs-w":"6"}},[_c('div',{staticClass:"mx-3 w-full row-card"},[_c('vs-col',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('div',{staticClass:"w-full py-1"},[_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('vs-col',{attrs:{"vs-w":"1","vs-type":"flex","vs-justify":"flex-start","vs-align":"flex-start"}}),_c('vs-col',{staticClass:"pt-3",attrs:{"vs-w":"10","vs-type":"flex","vs-justify":"center","vs-align":"center"}},[_c('h5',{staticClass:"font-semibold"},[_vm._v("PLANOS")])]),_c('vs-col',{attrs:{"vs-w":"1","vs-type":"flex","vs-justify":"flex-end","vs-align":"flex-end"}},[_c('infoTooltip',{attrs:{"color":"dark","titulo":"PLANOS","position":'left',"texto":_vm.tooltipTextos.planos}})],1)],1),_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('faturamentoChart',{attrs:{"planos":_vm.relatorioFaturamento.planos.data,"filtro":_vm.filtro,"label":' faturamentos'}}),_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('vs-col',{attrs:{"vs-type":"flex","vs-w":"6","vs-justify":"center","vs-align":"center"}},[_c('metaChart',{attrs:{"valores":[
                                  _vm.relatorioFaturamento.planos.metas.qtd_total,
                                  (_vm.relatorioFaturamento.planos.metas
                                    .qtd_meta /
                                    _vm.filtro.diasUteis) *
                                    _vm.filtro.diasCorridos
                                ],"percent":parseFloat(
                                    (_vm.relatorioFaturamento.planos.metas
                                      .qtd_total /
                                      ((_vm.relatorioFaturamento.planos.metas
                                        .qtd_meta /
                                        _vm.filtro.diasUteis) *
                                        _vm.filtro.diasCorridos)) *
                                      100
                                  ).toFixed(2),"label":"Total Contratos"}})],1),_c('vs-col',{attrs:{"vs-type":"flex","vs-w":"6","vs-justify":"center","vs-align":"center"}},[_c('metaChart',{attrs:{"valores":[
                                  _vm.$currency(
                                    parseFloat(
                                      _vm.relatorioFaturamento.planos.metas
                                        .valor_total
                                    )
                                  ),
                                  _vm.$currency(
                                    parseFloat(
                                      (_vm.relatorioFaturamento.planos.metas
                                        .valor_meta /
                                        _vm.filtro.diasUteis) *
                                        _vm.filtro.diasCorridos
                                    )
                                  )
                                ],"percent":parseFloat(
                                    (_vm.relatorioFaturamento.planos.metas
                                      .valor_total /
                                      ((_vm.relatorioFaturamento.planos.metas
                                        .valor_meta /
                                        _vm.filtro.diasUteis) *
                                        _vm.filtro.diasCorridos)) *
                                      100
                                  ).toFixed(2),"label":"Valor"}})],1)],1)],1)],1)])],1)]),_c('vs-col',{attrs:{"vs-type":"flex","vs-w":"6"}},[_c('div',{staticClass:"m-3 w-full row-card"},[_c('vs-col',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('div',{staticClass:"w-full py-1"},[_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('vs-col',{attrs:{"vs-w":"1","vs-type":"flex","vs-justify":"flex-start","vs-align":"flex-start"}}),_c('vs-col',{staticClass:"pt-3",attrs:{"vs-w":"10","vs-type":"flex","vs-justify":"center","vs-align":"center"}},[_c('h5',{staticClass:"font-semibold"},[_vm._v("PARCELAS")])]),_c('vs-col',{attrs:{"vs-w":"1","vs-type":"flex","vs-justify":"flex-end","vs-align":"flex-end"}},[_c('infoTooltip',{attrs:{"color":"dark","position":'left',"titulo":"PARCELAS","texto":_vm.tooltipTextos.parcelas}})],1)],1),_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('parcelasChart',{attrs:{"filtro":_vm.filtro,"label":' faturamentos',"parcelas":_vm.relatorioFaturamento.parcelas}})],1)],1)])],1)]),_c('vs-col',{attrs:{"vs-type":"flex","vs-w":"6"}},[_c('div',{staticClass:"m-3 w-full row-card"},[_c('vs-col',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('div',{staticClass:"w-full py-1"},[_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('vs-col',{attrs:{"vs-w":"1","vs-type":"flex","vs-justify":"flex-start","vs-align":"flex-start"}}),_c('vs-col',{staticClass:"pt-3",attrs:{"vs-w":"10","vs-type":"flex","vs-justify":"center","vs-align":"center"}},[_c('h5',{staticClass:"font-semibold"},[_vm._v("Para Faturar")])]),_c('vs-col',{attrs:{"vs-w":"1","vs-type":"flex","vs-justify":"flex-end","vs-align":"flex-end"}},[_c('infoTooltip',{attrs:{"color":"dark","position":'left',"titulo":"PARCELAS","texto":_vm.tooltipTextos.parcelas}})],1)],1),_c('vs-col',{staticClass:"mt-10",attrs:{"vs-w":"12","vs-type":"flex","vs-justify":"center","vs-align":"center"}},[_c('h3',[_vm._v("Mensal")])]),_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('vs-col',{attrs:{"vs-w":"6"}},[_c('metaChart',{attrs:{"valores":[
                                parseFloat(
                                  _vm.relatorioFaturamento.paraFaturar.data[0].qtd
                                ),
                                parseFloat(
                                  (_vm.relatorioFaturamento.paraFaturar.data[0]
                                    .meta_qtd /
                                    _vm.filtro.diasUteis) *
                                    _vm.filtro.diasCorridos
                                )
                              ],"percent":parseFloat(
                                  (_vm.relatorioFaturamento.paraFaturar.data[0]
                                    .qtd /
                                    ((_vm.relatorioFaturamento.paraFaturar.data[0]
                                      .meta_qtd /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos)) *
                                    100
                                ).toFixed(2),"label":"Quantidade"}})],1),_c('vs-col',{attrs:{"vs-w":"6"}},[_c('metaChart',{attrs:{"valores":[
                                _vm.$currency(
                                  parseFloat(
                                    _vm.relatorioFaturamento.paraFaturar.data[0]
                                      .valor
                                  )
                                ),
                                _vm.$currency(
                                  parseFloat(
                                    (_vm.relatorioFaturamento.paraFaturar.data[0]
                                      .meta_valor /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos
                                  )
                                )
                              ],"percent":parseFloat(
                                  (_vm.relatorioFaturamento.paraFaturar.data[0]
                                    .valor /
                                    ((_vm.relatorioFaturamento.paraFaturar.data[0]
                                      .meta_valor /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos)) *
                                    100
                                ).toFixed(2),"label":"Valor"}})],1)],1),_c('vs-col',{staticClass:"mt-16",attrs:{"vs-w":"12","vs-type":"flex","vs-justify":"center","vs-align":"center"}},[_c('h3',[_vm._v("Global")])]),_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('vs-col',{attrs:{"vs-w":"6"}},[_c('metaChart',{attrs:{"valores":[
                                parseFloat(
                                  _vm.relatorioFaturamento.paraFaturar.data[1].qtd
                                ),
                                parseFloat(
                                  (_vm.relatorioFaturamento.paraFaturar.data[1]
                                    .meta_qtd /
                                    _vm.filtro.diasUteis) *
                                    _vm.filtro.diasCorridos
                                )
                              ],"percent":parseFloat(
                                  (_vm.relatorioFaturamento.paraFaturar.data[1]
                                    .qtd /
                                    ((_vm.relatorioFaturamento.paraFaturar.data[1]
                                      .meta_qtd /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos)) *
                                    100
                                ).toFixed(2),"label":"Quantidade"}})],1),_c('vs-col',{attrs:{"vs-w":"6"}},[_c('metaChart',{attrs:{"valores":[
                                _vm.$currency(
                                  parseFloat(
                                    _vm.relatorioFaturamento.paraFaturar.data[1]
                                      .valor
                                  )
                                ),
                                _vm.$currency(
                                  parseFloat(
                                    (_vm.relatorioFaturamento.paraFaturar.data[1]
                                      .meta_valor /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos
                                  )
                                )
                              ],"percent":parseFloat(
                                  (_vm.relatorioFaturamento.paraFaturar.data[1]
                                    .valor /
                                    ((_vm.relatorioFaturamento.paraFaturar.data[1]
                                      .meta_valor /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos)) *
                                    100
                                ).toFixed(2),"label":"Valor"}})],1)],1),_c('vs-col',{staticClass:"mt-16",attrs:{"vs-w":"12","vs-type":"flex","vs-justify":"center","vs-align":"center"}},[_c('h3',[_vm._v("Total")])]),_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('vs-col',{attrs:{"vs-w":"6"}},[_c('metaChart',{attrs:{"valores":[
                                parseFloat(
                                  _vm.relatorioFaturamento.paraFaturar.data[1]
                                    .qtd +
                                    _vm.relatorioFaturamento.paraFaturar.data[0]
                                      .qtd
                                ),
                                parseFloat(
                                  (_vm.relatorioFaturamento.paraFaturar.data[1]
                                    .meta_qtd /
                                    _vm.filtro.diasUteis) *
                                    _vm.filtro.diasCorridos +
                                    (_vm.relatorioFaturamento.paraFaturar.data[0]
                                      .meta_qtd /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos
                                )
                              ],"percent":parseFloat(
                                  ((_vm.relatorioFaturamento.paraFaturar.data[1]
                                    .qtd +
                                    _vm.relatorioFaturamento.paraFaturar.data[0]
                                      .qtd) /
                                    ((_vm.relatorioFaturamento.paraFaturar.data[1]
                                      .meta_qtd /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos +
                                      (_vm.relatorioFaturamento.paraFaturar
                                        .data[0].meta_qtd /
                                        _vm.filtro.diasUteis) *
                                        _vm.filtro.diasCorridos)) *
                                    100
                                ).toFixed(2),"label":"Quantidade"}})],1),_c('vs-col',{attrs:{"vs-w":"6"}},[_c('metaChart',{attrs:{"valores":[
                                _vm.$currency(
                                  parseFloat(
                                    _vm.relatorioFaturamento.paraFaturar.data[1]
                                      .valor +
                                      _vm.relatorioFaturamento.paraFaturar.data[0]
                                        .valor
                                  )
                                ),
                                _vm.$currency(
                                  parseFloat(
                                    (_vm.relatorioFaturamento.paraFaturar.data[1]
                                      .meta_valor /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos +
                                      (_vm.relatorioFaturamento.paraFaturar
                                        .data[0].meta_valor /
                                        _vm.filtro.diasUteis) *
                                        _vm.filtro.diasCorridos
                                  )
                                )
                              ],"percent":parseFloat(
                                  ((_vm.relatorioFaturamento.paraFaturar.data[1]
                                    .valor +
                                    _vm.relatorioFaturamento.paraFaturar.data[0]
                                      .valor) /
                                    ((_vm.relatorioFaturamento.paraFaturar.data[1]
                                      .meta_valor /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos +
                                      (_vm.relatorioFaturamento.paraFaturar
                                        .data[0].meta_valor /
                                        _vm.filtro.diasUteis) *
                                        _vm.filtro.diasCorridos)) *
                                    100
                                ).toFixed(2),"label":"Valor"}})],1)],1)],1)])],1)]),_c('vs-col',{attrs:{"vs-type":"flex","vs-w":"6"}},[_c('div',{staticClass:"m-3 w-full row-card"},[_c('vs-col',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('div',{staticClass:"w-full py-1"},[_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('vs-col',{attrs:{"vs-w":"1","vs-type":"flex","vs-justify":"flex-start","vs-align":"flex-start"}}),_c('vs-col',{staticClass:"pt-3",attrs:{"vs-w":"10","vs-type":"flex","vs-justify":"center","vs-align":"center"}},[_c('h5',{staticClass:"font-semibold"},[_vm._v("Faturado")])]),_c('vs-col',{attrs:{"vs-w":"1","vs-type":"flex","vs-justify":"flex-end","vs-align":"flex-end"}},[_c('infoTooltip',{attrs:{"color":"dark","position":'left',"titulo":"PARCELAS","texto":_vm.tooltipTextos.parcelas}})],1)],1),_c('vs-col',{staticClass:"mt-10",attrs:{"vs-w":"12","vs-type":"flex","vs-justify":"center","vs-align":"center"}},[_c('h3',[_vm._v("Mensal")])]),_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('vs-col',{attrs:{"vs-w":"6"}},[_c('metaChart',{attrs:{"valores":[
                                parseFloat(
                                  _vm.relatorioFaturamento.faturados.data[0].qtd
                                ),
                                parseFloat(
                                  (_vm.relatorioFaturamento.faturados.data[0]
                                    .meta_qtd /
                                    _vm.filtro.diasUteis) *
                                    _vm.filtro.diasCorridos
                                )
                              ],"percent":parseFloat(
                                  (_vm.relatorioFaturamento.faturados.data[0]
                                    .qtd /
                                    ((_vm.relatorioFaturamento.faturados.data[0]
                                      .meta_qtd /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos)) *
                                    100
                                ).toFixed(2),"label":"Quantidade"}})],1),_c('vs-col',{attrs:{"vs-w":"6"}},[_c('metaChart',{attrs:{"valores":[
                                _vm.$currency(
                                  parseFloat(
                                    _vm.relatorioFaturamento.faturados.data[0]
                                      .valor
                                  )
                                ),
                                _vm.$currency(
                                  parseFloat(
                                    (_vm.relatorioFaturamento.faturados.data[0]
                                      .meta_valor /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos
                                  )
                                )
                              ],"percent":parseFloat(
                                  (_vm.relatorioFaturamento.faturados.data[0]
                                    .valor /
                                    ((_vm.relatorioFaturamento.faturados.data[0]
                                      .meta_valor /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos)) *
                                    100
                                ).toFixed(2),"label":"Valor"}})],1)],1),_c('vs-col',{staticClass:"mt-16",attrs:{"vs-w":"12","vs-type":"flex","vs-justify":"center","vs-align":"center"}},[_c('h3',[_vm._v("Global")])]),_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('vs-col',{attrs:{"vs-w":"6"}},[_c('metaChart',{attrs:{"valores":[
                                parseFloat(
                                  _vm.relatorioFaturamento.faturados.data[1].qtd
                                ),
                                parseFloat(
                                  (_vm.relatorioFaturamento.faturados.data[1]
                                    .meta_qtd /
                                    _vm.filtro.diasUteis) *
                                    _vm.filtro.diasCorridos
                                )
                              ],"percent":parseFloat(
                                  (_vm.relatorioFaturamento.faturados.data[1]
                                    .qtd /
                                    ((_vm.relatorioFaturamento.faturados.data[1]
                                      .meta_qtd /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos)) *
                                    100
                                ).toFixed(2),"label":"Quantidade"}})],1),_c('vs-col',{attrs:{"vs-w":"6"}},[_c('metaChart',{attrs:{"valores":[
                                _vm.$currency(
                                  parseFloat(
                                    _vm.relatorioFaturamento.faturados.data[1]
                                      .valor
                                  )
                                ),
                                _vm.$currency(
                                  parseFloat(
                                    (_vm.relatorioFaturamento.faturados.data[1]
                                      .meta_valor /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos
                                  )
                                )
                              ],"percent":parseFloat(
                                  (_vm.relatorioFaturamento.faturados.data[1]
                                    .valor /
                                    ((_vm.relatorioFaturamento.faturados.data[1]
                                      .meta_valor /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos)) *
                                    100
                                ).toFixed(2),"label":"Valor"}})],1)],1),_c('vs-col',{staticClass:"mt-16",attrs:{"vs-w":"12","vs-type":"flex","vs-justify":"center","vs-align":"center"}},[_c('h3',[_vm._v("Total")])]),_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('vs-col',{attrs:{"vs-w":"6"}},[_c('metaChart',{attrs:{"valores":[
                                parseFloat(
                                  _vm.relatorioFaturamento.faturados.data[1].qtd +
                                    _vm.relatorioFaturamento.faturados.data[0].qtd
                                ),
                                parseFloat(
                                  (_vm.relatorioFaturamento.faturados.data[1]
                                    .meta_qtd /
                                    _vm.filtro.diasUteis) *
                                    _vm.filtro.diasCorridos +
                                    (_vm.relatorioFaturamento.faturados.data[0]
                                      .meta_qtd /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos
                                )
                              ],"percent":parseFloat(
                                  ((_vm.relatorioFaturamento.faturados.data[1]
                                    .qtd +
                                    _vm.relatorioFaturamento.faturados.data[0]
                                      .qtd) /
                                    ((_vm.relatorioFaturamento.faturados.data[1]
                                      .meta_qtd /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos +
                                      (_vm.relatorioFaturamento.faturados.data[1]
                                        .meta_qtd /
                                        _vm.filtro.diasUteis) *
                                        _vm.filtro.diasCorridos)) *
                                    100
                                ).toFixed(2),"label":"Quantidade"}})],1),_c('vs-col',{attrs:{"vs-w":"6"}},[_c('metaChart',{attrs:{"valores":[
                                _vm.$currency(
                                  parseFloat(
                                    _vm.relatorioFaturamento.faturados.data[1]
                                      .valor +
                                      _vm.relatorioFaturamento.faturados.data[0]
                                        .valor
                                  )
                                ),
                                _vm.$currency(
                                  parseFloat(
                                    (_vm.relatorioFaturamento.faturados.data[1]
                                      .meta_valor /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos +
                                      (_vm.relatorioFaturamento.faturados.data[0]
                                        .meta_valor /
                                        _vm.filtro.diasUteis) *
                                        _vm.filtro.diasCorridos
                                  )
                                )
                              ],"percent":parseFloat(
                                  (_vm.relatorioFaturamento.faturados.data[1]
                                    .valor +
                                    _vm.relatorioFaturamento.faturados.data[0]
                                      .valor) /
                                    ((_vm.relatorioFaturamento.faturados.data[1]
                                      .meta_valor /
                                      _vm.filtro.diasUteis) *
                                      _vm.filtro.diasCorridos +
                                      (_vm.relatorioFaturamento.faturados.data[1]
                                        .meta_valor /
                                        _vm.filtro.diasUteis) *
                                        _vm.filtro.diasCorridos *
                                        100)
                                ).toFixed(2),"label":"Valor"}})],1)],1)],1)])],1)])],1)],1):_c('div',[_c('vs-row',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('vs-col',{attrs:{"vs-type":"flex","vs-w":"12","vs-justify":"center","vs-align":"center"}},[_c('p',{staticClass:"mt-10 pt-10",staticStyle:{"font-size":"30px","height":"250px"}},[_vm._v(" Carregando... "+_vm._s(_vm.loading)+"% ")])])],1)],1)])])])],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }